import React, { useState } from 'react';

function Filters({ onFilter }) {
  const [type, setType] = useState('');
  const [status, setStatus] = useState('');
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');

  const handleSubmit = e => {
    e.preventDefault();
    onFilter({ type, status, start, end });
  };

  return (
    <form onSubmit={handleSubmit} className="glass-form" style={{ padding: '0 1.5rem 1.5rem' }}>
      <input className="glass-input" placeholder="Tipo de Evento" value={type} onChange={e => setType(e.target.value)} />
      <input className="glass-input" placeholder="Status" value={status} onChange={e => setStatus(e.target.value)} />
      <input className="glass-input" placeholder="Início" type="date" value={start} onChange={e => setStart(e.target.value)} />
      <input className="glass-input" placeholder="Fim" type="date" value={end} onChange={e => setEnd(e.target.value)} />
      <button type="submit" className="btn-primary">Filtrar</button>
    </form>
  );
}

export default Filters;
